/**
 *	Main scripts used throughout the site
 */
import * as ArchiveLoading from './main/archive-loading';
import * as BlogSingle from './main/blog-single';
import * as MMenu from './main/mmenu';
import * as Cards from './main/cards';
import * as EqualHeights from './main/equal-heights';
import * as HeaderNav from './main/header-nav';
import * as NewsletterPopup from './main/newsletter-popup';
import * as Lazies from './main/lazies';
import * as StickyScroll from './main/sticky-scroll';
import * as Sliders from './main/sliders';
import * as Forms from './main/forms';
import * as Media from './main/media';
import * as Misc from './main/misc';
import * as SearchModal from './main/search-modal';
import * as Scrolling from './main/scrolling';



// WEBPACK FOOTER //
// ./assets/frontend/scripts/main.js